<template>
  <div>
    <div class="header">Service Types Management</div>

    <div class="left-panel">

      <select v-model="selectedBrand" @change="changeBrand" class="brands">
        <option v-for="(brand, index) in brands" :key="index" :value="brand.id">{{ brand.name }}</option>
      </select>

      <a :class="{'button cta success small block': true, 'disabled': serviceLoading}"
        @click="initAddService" :disabled="serviceLoading">
        <i class="fas fa-plus"></i>
        Add Service
      </a>

      <div class="service-list">
        <ul :class="{'disabled': serviceLoading}">
          <draggable v-model="serviceList" @change="positionChange"
            :disabled="serviceLoading" v-bind="dragOptions">
            <transition-group type="transition" :name="!drag ? 'flip-list' : null">
              <li v-for="service in serviceList" :key="service.id"
                :class="{'active': activeService === service.id}">
                <div class="left">
                  <i class="fas fa-grip-lines drag-icon"></i>
                </div>
                <div class="mid" @click="loadDetails(service.id)">
                  {{ service.name }}
                  <span>{{ service.id }} - {{ service.code }}</span>
                </div>
                <div class="right">
                  <div class="switch">
                    <div :class="{'slider':true, 'active': service.enabled, 'disabled':enabledLoading['a' + service.id] || serviceAreaLoading}"
                      @click="toggleServiceEnable(service.id, service.enabled)"></div>
                    <span class="label" v-if="service.enabled">Enabled</span>
                    <span class="label" v-else>Disabled</span>
                  </div>
                </div>
              </li>
            </transition-group>
          </draggable>
        </ul>
        <transition name="slide-down">
          <div class="loader" v-show="serviceLoading">
            <i class="fas fa-spinner fa-spin"></i> Loading
          </div>
        </transition>
      </div>
    </div>

    <div :class="['right-panel', activeService ? 'show' : 'hide']">
      <transition name="fade-right">
        <service-details ref="serviceDetails" v-show="transitionRightPanel"
          @response="response" @revalidate="showCloneModal"
          @clone="cloneResponse" @fieldChange="reRenderPreview"></service-details>
      </transition>

      <transition name="slide-up">
        <div class="fixed-bottom" v-show="activeService !== ''">
          <div class="row">
            <div class="column medium-12 end">
              <a :class="{'button cta small long-btn':true, 'disabled':saving || currentDetailsId === 0}"
                @click="revalidate">
                <i class="far fa-clone"></i>Use for other brands
              </a>
              <a :class="{'button cta small secondary short-btn':true, 'disabled':saving}"
                @click="cancelSelect" v-show="isMobile">
                <i class="fas fa-ban"></i>Cancel
              </a>
              <a :class="{'button cta small warning preview short-btn':true, 'disabled':saving}"
                @click="showPreview">
                <i class="far fa-eye"></i>Preview
              </a>
              <a :class="{'button cta small success save short-btn':true, 'disabled':saving}"
                @click="save">
                <div v-if="saving && !cloneModal.show"><i class="fas fa-spinner fa-spin"></i>Saving...</div>
                <div v-else><i class="fas fa-save"></i>Save</div>
              </a>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <preview v-if="renderPreview"></preview>

    <div :class="{'op--modal-container':true, 'hide': !responseModal.show}" @click="closeResponseModal">
      <div class="op--modal">
        <div class="op--modal-content" @click.stop>
          <div class="response-box">
            <i class="fas fa-check-circle fa-4x success"
              v-if="responseModal.status === 'success'"></i>
            <i class="fas fa-times-circle fa-4x error" v-else></i>
            <span class="message">{{ responseModal.message }}</span>
            <span class="extra" v-if="responseModal.extra">{{ responseModal.extra }}</span>
            <a class="button cta block" @click="openDriverModal" v-if="responseModal.status === 'success'">Enable on Drivers</a>
            <a class="button skip" @click="closeResponseModal">Skip</a>
          </div>
        </div>
      </div>
    </div>

    <div :class="{'op--modal-container':true, 'hide': !cloneModal.show}" @click="closeCloneModal">
      <div class="op--modal">
        <div class="op--modal-content" @click.stop>
          <div class="clone-box">
            <div v-if="cloneModal.status === ''">
              <p>
                Please select which brand you want to make a duplicate of
                <b>{{ currentServiceLabel }}</b>.
              </p>
              <select v-model="cloneModal.brand" class="brands">
                <option v-for="(brand, index) in brands"
                  :key="index" :value="brand.id">{{ brand.name }}</option>
              </select>
              <div class="row">
                <div class="column medium-6 p-R-10">
                  <a :class="{'button cta warning block':true, 'disabled':saving}"
                    @click="closeCloneModal">Cancel</a>
                </div>
                <div class="column medium-6">
                  <a :class="{'button cta success block':true, 'disabled':saving}"
                    @click="clone">
                    <div v-if="saving"><i class="fas fa-spinner fa-spin"></i>Saving...</div>
                   <div v-else>Add</div>
                  </a>
                </div>
              </div>
            </div>
            <div v-else>
              <i class="fas fa-check-circle fa-4x success"
                v-if="cloneModal.status === 'success'"></i>
              <i class="fas fa-times-circle fa-4x error" v-else></i>
              <span class="message">{{ cloneModal.message }}</span>
              <span class="extra" v-if="cloneModal.extra">{{ cloneModal.extra }}</span>
              <a class="button cta block" @click="closeCloneModal">Close</a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div :class="{'op--modal-container':true, 'hide': !driverModal.show}" @click="closeDriverModal">
      <div class="op--modal">
        <div class="op--modal-content" @click.stop>
          <div class="driver-box">
            <enable-drivers @clicked="closeDriverModal" @enableModal="showEnableDriverModal"></enable-drivers>
          </div>
        </div>
      </div>
    </div>

    <div :class="{'op--modal-container':true, 'hide': !enableDriverModal.show}" @click="closeEnableDriverModal">
      <div class="op--modal">
        <div class="op--modal-content" @click.stop>
          <div class="enable-driver-modal">
            <i class="fas fa-check-circle fa-4x success"
                v-if="enableDriverModal.status === 'success'"></i>
              <i class="fas fa-times-circle fa-4x error" v-else></i>
              <span class="message">{{ enableDriverModal.message }}</span>
              <a class="button cta block" @click="closeEnableDriverModal">Close</a>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
/* global CONFIG */
// import moment from 'moment'
import preview from './Preview'
import draggable from 'vuedraggable'
import ApiBrands from '@/modules/api/brands'
import serviceDetails from './ServiceDetails'
import ApiServices from '@/modules/api/services'
import ApiServiceArea from '@/modules/api/pricing/service-area'
import ApiProviderList from '@/modules/api/provider/list'
import enableDrivers from './EnableDrivers'

export default {
  name: 'services',
  components: { preview, draggable, serviceDetails, enableDrivers },
  data () {
    return {
      selectedBrand: this.$plugins.storage.getServiceBrand() || CONFIG.default.brandId,
      serviceList: [],
      tempServiceList: [],
      activeService: '',
      serviceLoading: false,
      drag: false,
      enabledLoading: {},
      addService: false,
      transitionRightPanel: false,
      responseModal: {
        show: false,
        status: '',
        message: '',
        extra: ''
      },
      cloneModal: {
        show: false,
        brand: '',
        status: '',
        message: '',
        extra: ''
      },
      driverModal: {
        show: false
      },
      enableDriverModal: {
        show: false,
        status: '',
        message: '',
      },
      selectOnload: '',
      renderPreview: true,
      serviceAreaList: [],
      serviceAreaLoading: false,
      isMobile: false
    }
  },
  computed: {
    brands () { return this.$store.state.brands.list },
    services () { return this.$store.state.services.list.filter(x => x.brandId === parseInt(this.selectedBrand)) },
    dragOptions() {
      return {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost'
      }
    },
    saving () { return this.$store.state.services.saving },
    currentDetailsId () { return this.$store.state.services.details.id },
    currentServiceLabel () { return this.$store.state.services.details.name },
    _brandId () { return this.$route.params.brandId },
    _serviceId () { return this.$route.params.serviceId }
  },
  methods: {
    setScreenSize() {
      let self = this
      if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        self.isMobile = true
      } else {
        self.isMobile = false
      }
    },
    cancelSelect() {
      let id = ''
      let self = this
      self.activeService = id
      self.transitionRightPanel = false
    },
    getBrandsList () {
      let self = this
      if (self.$store.state.brands.list.length) { return }

      self.serviceLoading = true
      ApiBrands.getBrands(self, function (res) {
        self.serviceLoading = false
      })
    },
    changeBrand () {
      let self = this
      self.serviceLoading = true
      self.activeService = ''
      self.transitionRightPanel = false
      self.serviceAreaList = []
      self.$plugins.storage.setServiceBrand(self.selectedBrand)
      self.$store.commit('services/setBrandId', self.selectedBrand)
      self.$store.commit('services/removeNewService')

      setTimeout(() => {
        self.serviceLoading = false
      }, 300)
    },
    getServices () {
      let self = this
      ApiServices.getAllService(self, r => {
        if (!r.error) {
          if (self.selectOnload) {
            self.$nextTick().then(() => {
              self.$forceUpdate()
              self.loadDetails(self.selectOnload)
              self.selectOnload = ''
            })
          } else {
            self.serviceLoading = false
          }
        }
      })
    },
    initAddService () {
      let index = this.services.findIndex(x => x.id === 0)
      if (index === -1) {
        this.activeService = ''
        this.$store.commit('services/addService', {
          id: 0,
          brandId: parseInt(this.selectedBrand),
          enable: false,
          label: 'New Service',
          code: 'new_service',
          color: '',
          allowTNC: true,
          allowTCP: false,
          isShared: false,
          poolP2P: false,
          poolFromAirport: false,
          poolToAirport: false,
          useShifts: false,
          optinAllow: false,
          optinPercent: 0,
          isRental: false,
          image: '',
          imageOff: '',
          name: 'New Service',
          maxPassengers: 1,
          maxLuggages: 1,
          excerptWeb: '',
          descriptionWeb: '',
          advantageWeb: '',
          stops: '',
          category: '',
          excerptApp: '',
          descriptionApp: '',
          slogan: '',
          defaultTip: 0,
          unavailableTimes: []
        })
        this.loadDetails(0)
      } else {
        this.loadDetails(0)
      }
    },
    positionChange () {
      this.serviceLoading = true
      this.tempServiceList = [...this.serviceList]
      this.updatePosition()
    },
    updatePosition () {
      let self = this
      if (self.tempServiceList.length) {
        let service = self.serviceList[self.tempServiceList.length - 1]
        ApiServices.updatePosition(self, {
          id: service.id,
          priority: self.tempServiceList.length
        }, res => {
          self.tempServiceList.pop()
          self.updatePosition()
        })
      } else {
        // self.serviceLoading = false
        self.getServices()
      }
    },
    toggleServiceEnable (id, enable) {
      let self = this
      if (self.enabledLoading['a' + id] || self.serviceAreaLoading) { return }
      self.enabledLoading['a' + id] = true

      ApiServices.toggleServiceEnable(self, {
        id: id,
        enabled: !enable
      }, res => {
        if (enable) {
          if (!self.serviceAreaList.length) {
            self.getAllServiceArea(id)
          } else {
            self.disabledOnAllServiceArea(id)
          }
          return
        }
        self.enabledLoading['a' + id] = false
        if (!res.error) {
          self.$forceUpdate()
          self.$nextTick().then(() => {
            self.$forceUpdate()
            self.serviceList = self.services
          })
        }
      })
    },
    getAllServiceArea (id) {
      let self = this
      self.serviceAreaLoading = true
      self.$sdk.get('/servicearea', {
        token: self.$store.state.session.sessionToken,
        brandId: self.selectedBrand,
        status: 'active',
        order: 'priority',
        orderAsc: 1,
        pageNum: 1,
        pageSize: 9999
      }, res => {
        self.serviceAreaLoading = false
        if (!res.error) {
          res.list.forEach(servicearea => {
            self.serviceAreaList.push(servicearea.id)
          })
          self.disabledOnAllServiceArea(id)
        }
      }, '2.0')
    },
    disabledOnAllServiceArea (id) {
      let self = this
      if (self.serviceAreaList.length) {
        self.serviceAreaLoading = true
        self.$sdk.post('/servicearea/' + self.serviceAreaList[0] + '/pricing', {
          token: self.$store.state.session.sessionToken,
          services: [
            {
              serviceTypeId: id,
              enabled: false
            }
          ]
        }, res => {
          self.serviceAreaLoading = false
          self.enabledLoading['a' + id] = false
          if (res.error) {
            console.log('ERROR')
            return
          }
          // self.serviceAreaList.shift()
          // if (self.serviceAreaList.length) {
          //   // self.disabledOnAllServiceArea(id)
          // } else {
          //   self.enabledLoading['a' + id] = false
          // }
        }, '2.0')
      }
    },
    loadDetails (id) {
      let self = this
      self.activeService = id
      self.transitionRightPanel = false
      let index = self.services.findIndex(x => x.id === id)
      self.$store.commit('services/setDetails', this.services[index])
      self.$store.commit('services/setServiceUnavailableData', {
        asap: this.services[index].unavailableTimeAsap,
        future: this.services[index].unavailableTimeFuture,
        p2p: this.services[index].unavailableTimP2p,
        fromAirport: this.services[index].unavailableTimFromAirport,
        toAirport: this.services[index].unavailableTimToAirport,
        startTime: this.services[index].unavailableTimeStart,
        endTime: this.services[index].unavailableTimeEnd
      })

      setTimeout(function () {
        if (self.$refs.serviceDetails.clearErrors()) {
          self.$refs.serviceDetails.clearErrors()
        }
        self.transitionRightPanel = true
      }, 200)
    },
    showPreview () { this.$store.commit('services/setPreview', true) },
    selectColor () {
      this.color = this.colors.hex ? this.colors.hex.substring(1, this.colors.hex.length) : '000000'
      this.showColor = false
    },
    save () {
      let isNewService = this.$store.state.services.details.id === 0
      if (isNewService) {
        if (this.$refs.serviceDetails.save()) {
          this.$refs.serviceDetails.save()
        }
      } else {
        if (this.$refs.serviceDetails.update()) {
          this.$refs.serviceDetails.update()
        }
      }
    },
    response (data) { this.responseModal = data },
    closeResponseModal () {
      let self = this
      this.responseModal.show = false
      setTimeout(() => {
        self.responseModal = {
          show: false,
          status: '',
          message: '',
          extra: ''
        }
      }, 500)
    },
    revalidate () {
      if (this.$refs.serviceDetails.revalidate()) {
        this.$refs.serviceDetails.revalidate()
      }
    },
    showCloneModal () { this.cloneModal.show = true },
    clone () {
      if (this.$refs.serviceDetails.clone(this.cloneModal.brand)) {
        this.$refs.serviceDetails.clone(this.cloneModal.brand)
      }
    },
    cloneResponse (data) { this.cloneModal = data },
    closeCloneModal () {
      this.cloneModal = {
        show: false,
        brand: '',
        status: '',
        message: '',
        extra: ''
      }
    },
    reRenderPreview () {
      let self = this
      self.renderPreview = false
      self.$nextTick().then(() => {
        self.renderPreview = true
      })
    },
    openDriverModal () {
      let self = this
      self.closeResponseModal()
      self.driverModal.show = true
      self.$store.commit('services/resetUsers')
      self.$store.commit('services/setUserCurrentPage', 1)
      self.$store.commit('services/setUserIsLoading', true)
      ApiProviderList.getList(self, {}, res => {
        self.$store.commit('services/setUserIsLoading', false)
        ApiServices.getEnabledDrivers(self, {}, res => {
        })
      })
    },
    closeDriverModal () {
      this.driverModal = {
        show: false
      }
    },
    showEnableDriverModal (data) { this.enableDriverModal = data },
    closeEnableDriverModal () {
      let self = this
      self.enableDriverModal = {
        show: false,
        status: '',
        message: '',
      }
      self.closeDriverModal()
    }
  },
  watch: {
    _brandId: function (val) { this.$store.commit('services/setBrandId', parseInt(val)) },
    services: function (val) { this.serviceList = val },
    _serviceId: function (val) { this.selectOnload = parseInt(val) }
  },
  mounted () {
    this.selectedBrand = this.$plugins.storage.getServiceBrand() || CONFIG.default.brandId
    if (this.$route.params.brandId) {
      this.selectedBrand = parseInt(this._brandId)
      this.$store.commit('services/setBrandId', this.selectedBrand)
    } else {
      this.$store.commit('services/setBrandId', parseInt(this.selectedBrand))
    }
    if (this.$route.params.serviceId) { this.selectOnload = parseInt(this._serviceId) }

    this.getBrandsList()
    this.getServices()
    this.setScreenSize()
  }
}
</script>

<style lang="scss" scoped>
$left-panel-width: 280px;

.m-B-10{ margin-bottom: 10px; }
.p-L-10{ padding-left: 10px; }
.p-R-10{ padding-right: 10px; }

.header{
  height: 50px;
  font-weight: 700;
  font-size: 22px;
  color: #3F2975;
  background-color: #fff;
  display: block;
  line-height: 50px;
  padding-left: 70px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.15);
}

.left-panel{
  width: $left-panel-width;
  height: calc(100% - 50px);
  background: #e8f0fb;
  position: fixed;
  top: 50px;
  left: 0;
  padding: 10px;
  overflow: auto;

  .brands{
    margin-bottom: 20px;
    border: 1px solid #ddd;
    padding: 10px;
    color: #333;
    height: 45px;
    position: relative;
    font-size:14px;
    outline: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-image: url('/assets/img/dropdown-arrow.png');
    background-repeat: no-repeat;
    background-position: right 50%;
    transition: all .35s ease;

    &.has-error{ border-color: #f20d0d; }
    &:disabled{ background-color: #eee; }
  }
  .service-list{
    position: relative;
    min-height: 50px;

    .loader{
      position: absolute;
      width: 80%;
      background: #fff;
      top: 50%;
      left: 10%;
      padding: 10px;
      text-align: center;
      font-size: 14px;
      font-style: italic;
      color: #777;
      margin-top: -25px;
      box-shadow: 0 0 4px rgba(0,0,0, .2);
      border-radius: 4px;

      i{
        color: #0D79F2;
        margin-right: 4px;
      }
    }
  }
  ul{
    list-style: none;
    padding: 0;
    margin: 6px 0;
    border: 1px solid #dedede;
    border-radius: 2px;
    overflow: hidden;
    box-shadow: 1px 1px 3px rgba(0,0,0, .1);

    &.disabled{ opacity: .5; }
    li{
      background: #fff;
      padding: 10px;
      font-size: 16px;
      border-bottom: 1px solid #dedede;
      font-weight: 600;
      cursor: pointer;

      &:last-child{ border-bottom: none; }
      &:hover{ background: #fafafa; }
      &.active{
        background: #f0f9ff;
        box-shadow: 0 0 0 3px #2f8cc7 inset;
      }
      .left, .mid, .right{
        display: inline-block;
        vertical-align: top;
      }
      .mid{
        width: calc(100% - 70px);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .drag-icon{
        color: #acb6c3;
        margin-right: 3px;
      }
      span{
        display: block;
        font-size:11px;
        color: #aaa;
        line-height: 1;
        font-weight: 100;
      }
    }
  }
}

.right-panel{
  width: calc(100% - (#{$left-panel-width}));
  height: calc(100% - 50px);
  position: fixed;
  top: 50px;
  left: $left-panel-width;
  background: #f4f9ff;
  padding: 10px 20px 70px;
  overflow: auto;

  .fixed-bottom{
    height: 50px;
    width: calc(100% - (#{$left-panel-width}));
    left: $left-panel-width;
    bottom: 0;
    position: fixed;
    background: #fff;
    border-top: 1px solid #b0c6e4;
    text-align: center;
    padding: 5px 0;
    box-shadow: 0 -2px 3px rgba(0,0,0, .1);
    z-index: 3;

    .button{
      text-transform: uppercase;
      margin: 0 5px;
      min-width: 160px;
      i{ margin-right: 7px; }
    }
  }
}

.row{ max-width: 100%; }
.box{
  background: #fff;
  border-radius: 2px;
  border: 1px solid #b0c6e4;
  padding: 15px;
  box-shadow: 0 2px 3px rgba(0, 0, 20, 0.1);

  &.general-settings{
    width: 750px;
    margin: 0 10px;
  }
}

.switch{
  position: relative;
  display: inline-block;
  vertical-align: top;

  .slider{
    position: relative;
    display: inline-block;
    width: 40px;
    height: 20px;
    border-radius: 20px;
    background: #ccc;
    position: relative;
    cursor: pointer;
    transition:all .15s linear;

    &.disabled{ opacity: .4; }
    &:before{
      content: '';
      position: absolute;
      top: 2px;
      left: 2px;
      width: 16px;
      height: 16px;
      border-radius: 50%;
      background: #fff;
      transition:all .25s ease-in-out;
      box-shadow: 1px 1px 2px rgba(0,0,0, .25);
    }
    &.active{
      background: #57d1b7;
      &:before{ left: 21px; }
    }
  }
  .label{
    display: block;
    font-size: 9px;
    color: #aaa;
    text-transform: uppercase;
  }
}

.flip-list-move { transition: transform 0s; }
.no-move { transition: transform 0s; }
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.op--modal-container {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.35);
  overflow: auto;
  opacity: 1;
  -webkit-transition: all 0.2s ease-in;
  -moz-transition: all 0.2s ease-in;
  -o-transition: all 0.2s ease-in;
  transition: all 0.2s ease-in;

  &.hide {
    top: -100%;
    opacity: 0;
  }
}
.op--modal {
  display: table;
  width: 100%;
  height: 100%;
}
.op--modal-content{
  display: table-cell;
  vertical-align: middle;

  .response-box, .clone-box, .driver-box, .enable-driver-modal{
    text-align: center;
    margin-bottom: 40px;
    background-color: #fff;
    border-radius: 4px;
    width: 100%;
    max-width: 400px;
    margin: 0 auto;
    box-shadow: 0 2px 8px rgba(0,0,0,0.3);
    position: relative;
    padding: 20px;
    .skip {
      background-color: #fff;
      color: #333 !important;
      margin-top: 5px !important;
    }
    .success{ color: #26D97A; }
    .error{ color: #F20D0D; }
    .message{
      display: block;
      margin-top: 10px;
      font-size: 15px;
      font-weight: 600;
    }
    .extra{
      border: 1px solid #f20d0d;
      background: #ffefef;
      border-radius: 4px;
      color: #000;
      padding: 5px;
      font-style: italic;
      font-size: 13px;
      display: block;
      margin-top: 10px;
    }
    .button { margin-top: 25px; }
  }
  .clone-box{
    select{ margin-bottom: 20px; }
    .message{ margin-bottom: 20px; }
    .button { margin-top: 0; }
  }
  .driver-box {
    max-width: 1160px;
  }
}

select{
  margin-top: 5px;
  border: 1px solid #ddd;
  padding: 10px;
  color: #333;
  height: 45px;
  position: relative;
  font-size:14px;
  outline: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-image: url('/assets/img/dropdown-arrow.png');
  background-repeat: no-repeat;
  background-position: right 50%;
  transition: all .35s ease;

  &.has-error{ border-color: #f20d0d; }
  &:disabled{ background-color: #eee; }
}

.slide-up-enter-active, .slide-up-leave-active { transition: all .3s ease; }
.slide-up-enter, .slide-up-leave-to {
  transform: translateY(30px);
  opacity: 0;
}

.slide-down-enter-active, .slide-down-leave-active { transition: all .3s ease; }
.slide-down-enter, .slide-down-leave-to {
  transform: translateY(-20px);
  opacity: 0;
}

.fade-right-enter-active, .fade-right-leave-active { transition: all .15s ease; }
.fade-right-enter, .fade-right-leave-to {
  transform: translateX(15px);
  opacity: 0;
}

@media only screen and (max-width: 430px) {

  .p-R-10 {
    padding: 0;
  }

  .clone-box {
    .row {
      display: flex;
      .column {
        width: 50%;
        padding: 0 10px;
      }
    }
  }
  .left-panel {
    width: 100%;
    padding: 20px 2rem 50px;
  }

  .right-panel {
    &.hide {
      width: 0;
      height: 0;
      position: unset;
    }
    &.show {
      width: 100%;
      height: 100%;
      position: fixed;
      left: 0;
      padding-bottom: 200px;
    }

    .fixed-bottom {
      width: 100%;
      left: 0;
      height: auto;
      padding: 10px;

      .column {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        gap: 2%;
      }

      .button {
        margin: 0;
        min-width: 100px;

        &.long-btn {
          width: 100%;
          margin-bottom: 5px;
        }

        &.short-btn {
          width: 32%;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Services/index.vue